module.exports = __webpack_public_path__ + "img/mind_skeleton_time_0.fb175c7d.png";